import FavoritesScreen from './FavoritesScreen'

export default FavoritesScreen
